import styles from "./simulacao-marca.module.scss";

/**
 * Classes da marca "Alterado na simulação" para a linha e a barra do Gantt; `pilula` é a barra
 * preenchida das visões Fornecedor e Local.
 */
export const SIMULACAO_MARCA_CLASSES = {
  linha: styles.linha,
  barra: styles.barra,
  pilula: styles.pilula,
};
